import { httpClient2 } from "modules/core/utils/httpClient2";

export const fetchAIAuthToken = async () => {
  const res = await httpClient2.get<{ token: string; expires_at: number }>(
    "/ai/auth/token"
  );

  return res.data;
};
